import styled from "styled-components";
import { SVGLinkedin, SVGYoutube } from "@/lib/svg";

export const Container = styled.div`
  display: flex;
  gap: 1.625rem;
  align-items: baseline;
`;

export const YoutubeLogo = styled(SVGYoutube as any)`
  width: 1.25rem;
  height: auto;
`;

export const LinkedInLogo = styled(SVGLinkedin as any)`
  width: 1.25rem;
  height: auto;
`;
